import React from 'react';
import { motion } from 'framer-motion';

const CleaningPricingTable = ({ title, data, icon: Icon }) => {
    return (
        <motion.div className="bg-white p-6 rounded-2xl shadow-lg border">
            <h3 className="text-xl font-bold text-secondary mb-4 flex items-center">
                <Icon className="h-6 w-6 text-primary mr-3" />
                {title}
            </h3>
            <div className="divide-y divide-gray-100">
                {data.map((item, index) => (
                    <div key={index} className="flex justify-between items-center py-3">
                        <span className="text-gray-700">{item.item}</span>
                        <span className="font-semibold text-primary text-lg">{item.price}</span>
                    </div>
                ))}
            </div>
        </motion.div>
    );
};

export default CleaningPricingTable;
